<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path fill="currentColor" d="M12,1C6,1,1,6,1,12c0,6.1,5,11,11,11s11-5,11-11S18,1,12,1z" />
    <polygon fill="#000" points="15.9,12 9.6,15.7 9.6,8.3 	" />
  </svg>
</template>
<script setup></script>
